import { render, staticRenderFns } from "./HuliInfo.vue?vue&type=template&id=fd2bd3ac"
import script from "./HuliInfo.vue?vue&type=script&lang=js"
export * from "./HuliInfo.vue?vue&type=script&lang=js"
import style0 from "./HuliInfo.vue?vue&type=style&index=0&id=fd2bd3ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports